const defaultText = 'Zoeken naar…';

export const SearchPlaceholders = [
    {
        max: 350,
        class: 'placeholder-small',
        text: window.headerSearchPlaceholder?.max350 ?? defaultText,
    },
    {
        max: 870,
        class: 'placeholder-small',
        text: window.headerSearchPlaceholder?.max870 ?? defaultText,
    },
    {
        max: 1000,
        class: 'placeholder-small',
        text: window.headerSearchPlaceholder?.max1000 ?? defaultText,
    },
    {
        max: 1150,
        class: 'placeholder-large',
        text: window.headerSearchPlaceholder?.max1150 ?? defaultText,
    },
    {
        max: 1260,
        class: 'placeholder-large',
        text: window.headerSearchPlaceholder?.max1260 ?? defaultText,
    },
    {
        max: Infinity,
        class: 'placeholder-large',
        text: window.headerSearchPlaceholder?.over1260 ?? defaultText,
    }
];
